import { render } from "./FilterDistributorCurah.vue?vue&type=template&id=1f35e3ae"
import script from "./FilterDistributorCurah.vue?vue&type=script&lang=js"
export * from "./FilterDistributorCurah.vue?vue&type=script&lang=js"
script.render = render

export default script